import React from 'react';
import { ContentPage } from 'modules2/content-page';
import { GenresCard } from './components';
import genresList from 'modules2/data-json/genres.json';
import container from "./Genres.container";

const Genres = (props) => {
  const { currentCountryCode } = props.radioState;
  let list = [];
  genresList.map((genre) => {
    if (genre.code === currentCountryCode || genre.code === '*') {
      list.push(genre);
    }
  });

  return (
    <ContentPage
      header={{
        title: 'Genres',
        description: '',
        controls: '',
      }}
      body={<GenresCard genresList={list} />}
    />
  );
};

export default container(Genres);
